<template>
	<v-dialog v-model="show" v-bind="$attrs" v-on="$listeners" :width="400">
		<v-card>
			<v-card-title class="headline error--text">
				<v-icon large color="error" class="mr-2">mdi-close-octagon-outline</v-icon>
				<span>{{ title }}</span>
				<v-spacer />
				<v-btn @click="show = false" tabindex="-1" icon><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pl-8 pt-6">{{ message }}</v-card-text>
			<v-card-actions>
				<slot></slot>
				<v-spacer></v-spacer>
				<v-btn @click="show = false" text> OK </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		value: Boolean,
		title: {
			type: String,
			default: 'Sorry, something went wrong!',
		},
		message: {
			type: String,
			default: 'There is no error, you should not see this message.',
		},
	},
	data: () => ({}),
	computed: {
		show: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},
};
</script>
